/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  retrieveReleasesFailure,
  retrieveReleasesSuccess,
} from '@store/scenario/pmo/pmo-slice';

export const retrieveReleasesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType('pmo/retrieveReleases'),
  concatMap(() => from(dependencies.pmoGateway.retrieveReleases()).pipe(
    map((releases: string[]) => retrieveReleasesSuccess(releases)),
    catchError(() => of(retrieveReleasesFailure('Failed to retrieve releases'))),
  )),
);

